import React, { useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3000";

const ChatGPTPrompt = ({ setTextContent, sendTextToAPI, selectedSpeaker }) => {
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt.trim()) return;
    setLoading(true);

    try {
        const textContent = document.getElementById("text-content")?.innerText || "";
        console.log("🛠 Sending to ChatGPT:", { userPrompt: prompt, textContent });

        const response = await fetch(`${API_BASE_URL}/chatgpt`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userPrompt: prompt, textContent }),
        });

        if (!response.ok) {
          console.error("🚨 ChatGPT API error:", response.statusText);
          return;
        }

        const data = await response.json();
        console.log("💬 ChatGPT Reply:", data);

        if (data.reply) {
            let cleanedText = data.reply.replace(/^Improved text:\s*/i, "");
            console.log("✅ Updating text content...");
            
            // ✅ First, update text content
            setTextContent(cleanedText);
            
            // ✅ Then, trigger new audio generation
            if (selectedSpeaker) {
                sendTextToAPI(cleanedText, selectedSpeaker, true, false); 
            }
        } else {
            console.error("🚨 No valid response from ChatGPT");
        }

    } catch (error) {
        console.error("❌ Error sending request to ChatGPT:", error);
    } finally {
        setLoading(false);
        setPrompt(""); // Clear input after sending
    }
};
  
    return (
      <div className="chatgpt-container">
        {/* ✅ Updated Button - No More Floating */}
        <button className="button" onClick={() => document.getElementById("chatgpt-form").classList.toggle("show")}>
          Ask ChatGPT
        </button>
  
        {/* ✅ ChatGPT Input Form - Hidden Until Button Clicked */}
        <form id="chatgpt-form" className="chatgpt-form" onSubmit={handleSubmit}>
          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Enter a prompt..."
            className="chatgpt-input"
          />
          <button type="submit" className="button chatgpt-submit" disabled={loading}>
            {loading ? "⏳" : "Send"}
          </button>
        </form>
      </div>
    );
  };
  
  export default ChatGPTPrompt;